export const PORT_TYPE_MAP = {
  0: 'mbps',
  1: 'fiber',
  2: 'fiber',
  3: 'plus',
  4: 'q28',
  5: 'lockMbps',
  10: 'hdmi'
};
